import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VideoForm from "../../components/forms/VideoForm";
import useGetVideoDetails from "../../hooks/api/video/useGetVideoDetails";
import BasePage from "../common/BasePage";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Params = {
  videoId: string;
};

export default function EditVideoPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { videoId } = useParams<Params>();
  const {
    data: video,
    isLoading,
    isError,
    refetch,
  } = useGetVideoDetails(videoId ?? "");

  const onSuccess = useCallback(() => {
    navigate(`..`);
    toast({
      title: t("edit_video_page.video_updated"),
      description: t("edit_video_page.video_updated_message"),
      status: "success",
      isClosable: true,
    });
  }, [navigate, t, toast]);

  const onError = useCallback(() => {
    toast({
      title: t("edit_video_page.video_error"),
      description: t("edit_video_page.video_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage
      title={t("edit_video_page.edit_video")}
      description={`${t("edit_video_page.uploaded_by")}: ${video?.createdBy.fullName}`}
      isLoading={isLoading}
      hasError={isError}
      retry={refetch}
    >
      <VideoForm video={video} onSuccess={onSuccess} onError={onError} />
    </BasePage>
  );
}
